export type IdentificationReportStatus = "WAITING_DOCUMENTS" | "QUEUED" | "RETRYING" | "SENT" | "UNKNOWN";

export interface IdentificationReportResponse {
    processId: string | null;
    status: IdentificationReportStatus;
}

/** Retains HTTP status so recovery can distinguish permanent invitation failures from transient errors. */
export class IdentificationRequestError extends Error {
    /** Captures the HTTP status without exposing response content. */
    constructor(public readonly status: number) {
        super("Identification request failed");
    }
}
